import Vue from 'vue';
import Ele from 'element-ui'
import App from './App.vue';
import router from './router'
import store from './store'
import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'

import vuescroll from 'vuescroll';
import BaiduMap from 'vue-baidu-map'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条样式

import draggable from "vuedraggable"
import Vdr from 'vue-draggable-resizable-gorkys'

import 'babel-polyfill'
Vue.use(Ele);

Vue.config.productionTip = true;

Vue.component('draggable', draggable);
Vue.component('vdr', Vdr);

Vue.use(vuescroll, {
    ops: {
        rail: {
            opacity: '0',
            background: '#CCC',
            border: '0px solid #cecece',
            size: '5px',
            keepShow: false
        },
        bar: {
            onlyShowBarOnScroll: false,
            background: '#909399',
            keepShow: false,
            size: '5px',
            minSize: 0.2
        },
        scrollButton: {
            enable: false,
            background: '#909399'
        },
        scrollPanel: {
            easing: 'easeInQuad',
            speed: 800,
            scrollingX: false
        },
        vuescroll: {
            wheelScrollDuration: 0,
            wheelDirectionReverse: false
        }
    }, // 在这里设置全局默认配置
    name: 'myScroll' // 在这里自定义组件名字，默认是vueScroll
});

Vue.use(AlloyFingerPlugin, {
    AlloyFinger
});


Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: '2GnsAmvXS1gmwLqhBVWe9qOu'
})

Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999,
        navbar: false,
        title: false
        /*toolbar: {
    //zoomIn: 4,
    //zoomOut: 4,
    //oneToOne: 4,
    //reset: 4,
    prev: 1,
    play: {
    show: 4,
    size: 'large',
    },
    next: 1,
    //rotateLeft: 4,
    //rotateRight: 4,
    //flipHorizontal: 4,
    //flipVertical: 4,
    } */
    }
})

const requireComponent = require.context(
    // 其组件目录的相对路径
    './components/base',
    // 是否查询其子目录
    false,
    // 匹配基础组件文件名的正则表达式
    /ff\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
    // 获取组件配置
    const componentConfig = requireComponent(fileName)

    // 获取和目录深度无关的文件名
    const componentName = fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '');
    // 全局注册组件
    Vue.component(
        componentName,
        // 如果这个组件选项是通过 `export default` 导出的，
        // 那么就会优先使用 `.default`，
        // 否则回退到使用模块的根。
        componentConfig.default || componentConfig
    )
});

const clickoutsideContext = '@@clickoutsideContext';
Vue.directive('Clickoutside', {
    bind(el, binding, vnode) {
        const documentHandler = (e) => {
            if (vnode.context && !el.contains(e.target)) {
                vnode.context[el[clickoutsideContext].methodName]();
            }
        };
        el[clickoutsideContext] = {
            documentHandler,
            methodName: binding.expression,
            arg: binding.arg || 'click',
        };
        document.addEventListener(el[clickoutsideContext].arg, documentHandler);
    },
    update(el, binding) {
        el[clickoutsideContext].methodName = binding.expression;
    },
    unbind(el) {
        document.removeEventListener(
            el[clickoutsideContext].arg,
            el[clickoutsideContext].documentHandler);
    }
});

NProgress.configure({ ease: 'ease', speed: 500 })

NProgress.start();
NProgress.done();

router.beforeEach((to, from, next) => {
    NProgress.start();

    let _title = '韬客英语-TOKEnglish';
    window.document.title = _title;

    let _toptitle = '';
    switch (to.params.root) {
        case 'tp':
            _toptitle = 'Placement Evaluation';
            break;
        case 'tsr':
            _toptitle = 'Story Room';
            break;
        case 'tdl':
            _toptitle = 'The Digital Library';
            break;
        case 'tpl':
            _toptitle = '  ';
            break;
    }
    store.commit('SET_HF', _toptitle);


    let affdisplay = 'block';
    if (to.params) {

        if ((to.params.root == 'member') || (to.params.root == 'course') || (to.params.root == 'tsr') || (to.params.root == 'tp') || (to.params.root == 'tdl')) {
            affdisplay = 'none';
        }
    }

    if (document.querySelector('#newBridge')) {
        document.querySelector('#newBridge').style.display = affdisplay;
    }
    else {
        let affinterval = window.setInterval(function () {
            if (document.querySelector('#newBridge')) {
                document.querySelector('#newBridge').style.display = affdisplay;
                window.clearInterval(affinterval);
            }
        }, 50);
    }

    next();
});

Vue.directive('title', {
    inserted: function (el) {
        document.title = el.dataset.title || '韬客英语-TOKEnglish';
    }
})

router.afterEach(() => {
    NProgress.done();
})

Vue.directive('focus', function (el, option) {
    if (option.value) {
        Vue.nextTick(function () {
            el.querySelector('a').focus();
        })
    }

});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
